<template>
 <div class="mobile-menu fixed bg-white shadow w-full h-full right-0 top-0  z-50" style="max-width: 276px;">
        <div class="absolute transform translate-y-4 -translate-x-full w-12 h-12 bg-white flex justify-center items-center rounded-l-md" :class="{'left-0' : isRtl}" @click="$emit('click')">
            <svg class="h-8 w-8 text-support-300 fill-current" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.24 14.83C16.4038 15.0213 16.4894 15.2674 16.4797 15.519C16.47 15.7707 16.3656 16.0095 16.1876 16.1876C16.0095 16.3656 15.7707 16.47 15.519 16.4797C15.2674 16.4894 15.0213 16.4038 14.83 16.24L12 13.41L9.16999 16.24C8.97869 16.4038 8.73261 16.4894 8.48094 16.4797C8.22926 16.47 7.99052 16.3656 7.81243 16.1876C7.63433 16.0095 7.53 15.7707 7.52028 15.519C7.51056 15.2674 7.59616 15.0213 7.75999 14.83L10.59 12L7.75999 9.16999C7.59616 8.97869 7.51056 8.73261 7.52028 8.48094C7.53 8.22926 7.63433 7.99052 7.81243 7.81243C7.99052 7.63433 8.22926 7.53 8.48094 7.52028C8.73261 7.51056 8.97869 7.59616 9.16999 7.75999L12 10.59L14.83 7.75999C15.0213 7.59616 15.2674 7.51056 15.519 7.52028C15.7707 7.53 16.0095 7.63433 16.1876 7.81243C16.3656 7.99052 16.47 8.22926 16.4797 8.48094C16.4894 8.73261 16.4038 8.97869 16.24 9.16999L13.41 12L16.24 14.83Z"/>
            </svg>
        </div>
        <nav class="mt-16" :class="{'rtl-cl': !isRtl}" @click="$emit('click')">
            <router-link to="/" class="block px-6 py-4" active-class="bg-gray-200" exact>{{ $t('nav.home') }}</router-link>
            <router-link to="/about" class="block px-6 py-4" active-class="bg-gray-200">{{ $t('nav.about') }}</router-link>
            <router-link to="/contact" class="block px-6 py-4" active-class="bg-gray-200">{{ $t('nav.contact') }}</router-link>
            <hr class="my-6">
            <div class="px-6">
                <btn to="/register" :is-mobile="true" type="normal" color="secondary" class="mb-4 text-center">{{$t('btn.register')}}</btn>
                 <a href="http://app.awronore.krd"  
                 target="_blank"  
                 class="bg-support-700 w-full text-white py-2 px-3 rounded inline-flex justify-center items-center focus:bg-support-500 "
                >
                     <svg  class="fill-current w-4 h-4" :class="[{'ml-2': isRtl},{'mr-2': !isRtl}]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M13 8V2H7v6H2l8 8 8-8h-5zM0 18h20v2H0v-2z"/></svg>
                    <span>
                        {{$t('btn.download')}}
                    </span>
                </a>
            </div>
        </nav>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Btn from '@/components/Button';
export default {
    name: 'VerticalMenu',
    components: {Btn},
    computed: {
        ...mapGetters({
            isRtl: ['locale/IS_RTL']
        })
    }
}
</script>